export const APP_NAME = 'Maco'

export const DATE_FORMATS = {
  dots: 'MM.dd.yyyy',
  dotsShort: 'MM.dd',
  iso: 'yyyy-MM-dd',
  dateWithTime: 'MM.dd (h:mm a)',
  dateWithTimeSeconds: 'MM.dd (h:mm:ss a)',
  shortDateWithTime: 'MMM d (h:mm a)',
  full: 'EEEE MM.dd (h:mm a)',
  slash: 'MM/dd/yy',
  time: 'HH:mm',
  year: 'yyyy',
  dayFullMonth: 'MMMM d',
  dayShortMonth: 'MMM d',
  day: 'd',
  shortDay: 'eee d',
  monthName: 'MMMM',
  fullMonthYear: 'MMMM d, yyyy',
  mothShort: 'MMM',
  dateTimeLocal: "yyyy-MM-dd'T'HH:mm:ss"
} as const

export const ACCESS_TOKEN_KEY = 'maco_access_token'
export const REFRESH_TOKEN_KEY = 'maco_refresh_token'
export const USER_ID_KEY = 'maco_user_id'

export const DATE_PLACEHOLDER = '--.-- (--:--)'

export const DEFAULT_TZ = 'America/Toronto'
